import './scss/main.scss';
// Plyr video player
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import './scripts/case.js';
import './scripts/native.js';
import './scripts/faq.js';
// import Swiper
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';


// import AOS
import AOS, { init } from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import { Pagination } from 'swiper/modules';
// ..
AOS.init();

// import tippy from 'tippy.js';
// import 'tippy.js/dist/tippy.css'; // optional for styling




// couht total amount of logo-items within the swiper on the page and save it to a variable
var totalLogoItems = document.querySelectorAll('.logo-item').length;
 //console.log("The total amount of logo items is: " + totalLogoItems);

 var mysliderspeed = totalLogoItems * 1000;
//console.log("The speed of the slider is: " + mysliderspeed);
// adjust speed according to the total amount of logo items fewer logos is faster and more logos is slower
// Initialize Swiper for each container with class starting with "logoswiper"

// Initialize Swiper for each container with class starting with "mylogoswiper"
document.querySelectorAll('.mylogoswiper').forEach(function (swiperContainer) {
  var swiper = new Swiper(swiperContainer, {
    // enable navigation 
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    spaceBetween: 40,
  grabCursor:false,
  a11y: false,
  freeMode: true,
  speed:18000,
  loop: true,
  slidesPerView: "auto",
  autoplay: {
    delay: 0,
    // pauseOnMouseEnter: false,
    // disableOnInteraction: false,
     },
   breakpoints: {
    0: { /* when window >=0px - webflow mobile landscape/portriat */
      spaceBetween: 30,
    },
        480: { /* when window >=0px - webflow mobile landscape/portriat */
      spaceBetween: 30,
    },
    767: { /* when window >= 767px - webflow tablet */
      spaceBetween: 40,
    },
    992: { /* when window >= 988px - webflow desktop */
      spaceBetween: 40,
    }
  },
  });
  // Attach click event listener to the next button for this swiper instance
swiperContainer.querySelector('.swiper-button-next').addEventListener('click', function () {
  // swiper.speed = 0;
  swiper.autoplay.pauseOnMouseEnter = false;  
  //console.log("click next");
  swiper.slideTo(swiper.activeIndex, 0, false); // Force end transition
  swiper.params.autoplay.reverseDirection = true; // Reverse the direction
  swiper.slidePrev(); // Move to the previous slide
  swiper.autoplay.start(); // Start the autoplay
});

// Attach click event listener to the prev button for this swiper instance
swiperContainer.querySelector('.swiper-button-prev').addEventListener('click', function () {
  // first pause the autoplay then slide to the next slide
  // swiper.speed = 0;
   //console.log("click prev");
  swiper.slideTo(swiper.activeIndex, 0, false); // Force end transition
  swiper.params.autoplay.reverseDirection = false; // Reverse the direction
  swiper.slideNext(); // Move to the next slide
  swiper.autoplay.start(); // Start the autoplay
  
});
// on mouse hover pause 


});




 jQuery(document).ready(function ($) {

  // get if user scrolls up or down
  var lastScrollTop = 0;
  $(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
      // downscroll code
      //console.log("downscroll");
      // add class to the header
      $("header.site-header").addClass("downscroll");
  
    } else {
      // upscroll code
      //console.log("upscroll");
      // remove class from the header
      $("header.site-header").removeClass("downscroll");

    }
    lastScrollTop = st;
  }
  );
  
     /******************************************************************************\
    	Sticky header
    \******************************************************************************/
    var scroll = $(window).scrollTop();
    var getsiteheaderheight = $("header.site-header").height();
    //console.log("The site header height is: " + getsiteheaderheight);
    if (scroll >= getsiteheaderheight) {
      $("header.site-header").addClass("sticky-header");
      $("main.site-content").addClass("sticky-header");
    }
    $(window).scroll(function() {
      scroll = $(window).scrollTop();
    
      if (scroll >= getsiteheaderheight) {
        $("header.site-header").addClass("sticky-header");
        $("main.site-content").addClass("sticky-header");
      } else {
        $("header.site-header").removeClass("sticky-header");
        $("main.site-content").removeClass("sticky-header");
      }
    });
  



	/* Toggle sub menu in mobile */
  $('.sub-menu-toggle').on('click', (e) => {

    $(e.currentTarget).parent().parent().toggleClass('is-open');
  });
  /* Toggle mobile menu */
  $('.hamburger-menu').on('click', function() {
    $('.nav-primary__mobile').toggleClass('is-open');
    $('.site-header').toggleClass('mobile-menu-open');
    $('body').toggleClass('mobile-menu-open');
  });
  
  	/* Click outside of mobile menu closes it as well */
		// $(document).on('mouseup', function(e) {
		// 	if ( $('.nav-primary__mobile').hasClass('is-open') && !$('.nav-primary__mobile').is(e.target) && $('.nav-primary__mobile').has(e.target).length === 0) {
		// 		$('.nav-primary__mobile').toggleClass('is-open');
		// 	}
		// });

    	   /******************************************************************************\
      SMOOTH SCROLLING 
    \******************************************************************************/
	$('a[href*=#]:not([href=#])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		//scroll amount is the same as the height of the hero section
	
		var scrollTotal = 0;
		if ($(".hero").length) {
			scrollTotal = $(".hero").height();
		}

		  // if the target exists
		// do this only if clicked on .mouse_scroll or .mouse_scroll a
		if ($(this).hasClass("mouse_scroll") || $(this).parent().hasClass("mouse_scroll")) {
			if (target.length) {
				$('html,body').animate({
					scrollTop: scrollTotal 					
				}, 1000);
				return false;
			  }		
		}
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - 100					
			}, 1000);
			return false;
		  }	

		
		}
	  });


  // VIDEO EXPANDING SECTION
// do this if there is a video element on the page
if (document.getElementById("myVideo")) {
  // Setup the PLYR videoplayer
  const selector = '#myVideo';
  const player = new Plyr(selector, {
    keyboard: {
      global: true,
    },
    tooltips: {
      controls: true,
    },
    captions: {
      active: true,
    },
    controls: ['play-large','play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'],
    vimeo: {
      // Prevent Vimeo blocking plyr.io demo site
      referrerPolicy: 'no-referrer',
    },
  });

 var expandDiv = document.getElementById("expand");
 var videoContainer = document.getElementById("video-container");
 var speed = 5;

function expanding() {
  var scrolltop = window.pageYOffset; // get number of pixels document has scrolled vertically
  var scrollAndSpeed = (scrolltop / speed);
  //Expand using transform
  //expandDiv.style.transform = "scalex( " + Math.min(Math.max(scrollAndSpeed, 1), 10) + ")";
   // get the margin top of the video element
   var marginTop = window.getComputedStyle(videoContainer).getPropertyValue("margin-top");
  // get the height of the div
  var height = expandDiv.clientHeight;

  // get myVideo y position from the top
  var myVideo = document.getElementById("myVideo");
  var site_header = document.getElementById("masthead");
  var site_header_height = site_header.clientHeight;
//   target multiple elements that start with the same id so it works with myVideo1, myVideo2, myVideo3 etc


  var y = myVideo.getBoundingClientRect().top;
  // console.log("Get the y video element position is: " + y);
  // console.log("The scrolltop is: " + scrolltop);
 
 

  // get the initial border radius of the expand div and save it in a variable 

  var initialBorderRadius = window.getComputedStyle(expandDiv).getPropertyValue("border-radius");
  // console.log("The initial border radius is: " + initialBorderRadius);


  // when expandDiv hits the top of the viewport
var expandDivRect = expandDiv.getBoundingClientRect();
var videoexpanded = false;

// if (expandDivRect.top <= 0 + site_header_height) {
  if (expandDivRect.top <= 0 + site_header_height && expandDivRect.bottom >= 0 + site_header_height) {
  // console.log("expandDiv has hit the top of the viewport");
  videoexpanded = true;
  // Add your logic here for when expandDiv hits the top of the viewport
  expandDiv.classList.remove("not-scrolled");
  expandDiv.classList.add("scrolled");
  // expandDiv.style.width = "100%";
  var video = document.getElementById("myVideo");
  // unmute the video
  video.muted = true;
  // play the video
  //video.play();
  // is the video in view then play 
  if (video instanceof HTMLVideoElement) {
  video.play();
  }
  // console.log("Yes fire this:");
  // play only if expanddiv has the class scrolled and video expand is true
  // if (expandDiv.classList.contains("scrolled") && videoexpanded == true) {
  //   // play the video
  //   if (video instanceof HTMLVideoElement) {
  //     video.play();
  //   }
  // }

 
}
// if the top hits the bottom close videoexpanded false
if (expandDivRect.top >= 0 + 200) {
  videoexpanded = false;
  expandDiv.classList.remove("scrolled");
  expandDiv.classList.add("not-scrolled");
  var video = document.getElementById("myVideo");
  // mute the video
  // video.muted = true;
  //  check if myVideo is type of <video> element then pause the video
  if (video instanceof HTMLVideoElement) {
  video.pause();
  }
} 

if (expandDivRect.bottom <= 0) {
  //console.log("expandDiv has hit the bottom of the viewport");
  videoexpanded = false;
  expandDiv.classList.remove("scrolled");
  expandDiv.classList.add("not-scrolled");
  var video = document.getElementById("myVideo");
  // mute the video
  // video.muted = true;
  //  check if myVideo is type of <video> element then pause the video
  if (video instanceof HTMLVideoElement) {
  video.pause();
  }
}

//console.log("The video expanded is: " + videoexpanded);

if (scrolltop < 1 ) { 
  var video = document.getElementById("myVideo");
  if (video instanceof HTMLVideoElement) {
    video.pause();
    }
  expandDiv.classList.remove("scrolled");
  expandDiv.classList.add("not-scrolled");
}

// console.log("The video expanded is: " + videoexpanded);
// abort play if the video is not expanded
if (videoexpanded == false) {
  var video = document.getElementById("myVideo");
  if (video instanceof HTMLVideoElement) {
    video.pause();
    }
}

}

window.addEventListener('scroll', function() { // on page scroll
  requestAnimationFrame(expanding); // call parallaxing()
}, false);
// END OF VIDEO EXPANDING SECTION
}
});

// shifting words
document.addEventListener('DOMContentLoaded', function() {
  var alternatingText = document.querySelector('.alternatingtext');
  if (alternatingText) {
      var words = alternatingText.querySelectorAll('.word');
      if (words.length > 1) {
          words.forEach((word, index) => {
              if (index !== 0) {
                  word.style.display = 'none';
                  word.style.opacity = 0;
              }
          });

          let currentIndex = 0;

          function showNextWord() {
              words[currentIndex].style.display = 'none';
              words[currentIndex].style.opacity = 0;
              currentIndex = (currentIndex + 1) % words.length;
              words[currentIndex].style.display = 'block';
              setTimeout(() => {
                  words[currentIndex].style.opacity = 1;
              }, 10); // Small delay to trigger the transition
          }

          // Show the first word immediately
          showNextWord();

          // Shift every 2 seconds
          setInterval(showNextWord, 2000);
      } else if (words.length === 1) {
          // If there is only one word, ensure it is displayed
          words[0].style.display = 'block';
          words[0].style.opacity = 1;
      }
  }
});

// logoslider

// only do this if there is a logotype-slider on the page

document.querySelectorAll(".logo-slider").forEach(function (logoSlider) {
  var logosSlide = logoSlider.querySelector(".logos-slide");
  if (logosSlide) {
    var copy1 = logosSlide.cloneNode(true);
    // var copy2 = logosSlide.cloneNode(true);
    // var copy3 = logosSlide.cloneNode(true);
    // var copy4 = logosSlide.cloneNode(true);
    // var copy5 = logosSlide.cloneNode(true);
    logoSlider.appendChild(copy1);
    // logoSlider.appendChild(copy2);
    // logoSlider.appendChild(copy3);
    // logoSlider.appendChild(copy4);
    // logoSlider.appendChild(copy5);
  
  }
});


// regular video player
const videoElements = document.querySelectorAll('.myregularvideo');
if (videoElements.length > 0) {
  videoElements.forEach(function (videoElement) {
    // Setup the PLYR videoplayer for each element
    const player = new Plyr(videoElement, {
      keyboard: {
        global: true,
      },
      tooltips: {
        controls: true,
      },
      captions: {
        active: true,
      },
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'],
      vimeo: {
        // Prevent Vimeo blocking plyr.io demo site
        referrerPolicy: 'no-referrer',
      },
    });
    // autoplay if in view

    // check if the videElement is in view
  });
}

// for every .myregularvideo element on the page check if it is in view and play the video
document.addEventListener('DOMContentLoaded', function() {
  var videoElements = document.querySelectorAll('.myregularvideo');
  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var video = entry.target;
        if (video instanceof HTMLVideoElement) {
          video.play();
        }
      }
    });
  }, {
    threshold: 0.5
  });
  videoElements.forEach(function(videoElement) {
    observer.observe(videoElement);
  });
});



const videoElements_regularvideo = document.querySelectorAll('.text-block-video-regular');
if (videoElements_regularvideo.length > 0) {
  videoElements_regularvideo.forEach(function (videoElement) {
    // Setup the PLYR videoplayer for each element
    const player = new Plyr(videoElement, {
      keyboard: {
        global: true,
      },
      tooltips: {
        controls: true,
      },
      captions: {
        active: true,
      },
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'],
      vimeo: {
        // Prevent Vimeo blocking plyr.io demo site
        referrerPolicy: 'no-referrer',
      },
    });
  });
}

// text block video for use in anmation video that need to play direct without user interaction or any controls
const textblockvideo = document.querySelectorAll('.text-block-video-autoplay');
if (textblockvideo.length > 0) {
  textblockvideo.forEach(function (videoElement) {
    // Setup the PLYR videoplayer for each element
    const player = new Plyr(videoElement, {
      keyboard: {
        global: true,
      },
      tooltips: {
        controls: true,
      },
      captions: {
        active: true,
      },
      controls: [ ],
      vimeo: {
        // Prevent Vimeo blocking plyr.io demo site
        referrerPolicy: 'no-referrer',
      },
      loop: { active: false },
      // autoplay
      autoplay: false,
      // turn off interaction
      clickToPlay: false,
    });
  });
}
// if in view play video
document.addEventListener('DOMContentLoaded', function() {
  var videoElements = document.querySelectorAll('.play-video-in-view');
  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var video = entry.target;
        if (video instanceof HTMLVideoElement) {
          video.play();
        }
      }
    });
  }, {
    threshold: 0.5
  });
  videoElements.forEach(function(videoElement) {
    observer.observe(videoElement);
  });
}
);




// Trigger different animation that are defined in the css file when the element is in view used for timeline
document.addEventListener('DOMContentLoaded', function() {
  var animateElements = document.querySelectorAll('.animate');

  // Create an Intersection Observer instance
  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view'); // Add the class to trigger the animation
        observer.unobserve(entry.target); // Stop observing the element once it has been animated
      }
    });
  }, {
    threshold: 0.1 // Trigger when 10% of the element is in view
  });

  // Observe each animate element
  animateElements.forEach(function(animateElement) {
    observer.observe(animateElement);
  });
});

// new subpages expanding video on scroll and play video when in view
document.addEventListener('DOMContentLoaded', function() {
  const videoElements = document.querySelectorAll('[class^="mysubpageVideo"]');
  const expandDivs = document.querySelectorAll('[class^="expand-subpage"]');
  const videoContainers = document.querySelectorAll('[class^="video-container-subpage"]');

  //console.log('Video Elements:', videoElements);
  //console.log('Expand Divs:', expandDivs);
  //console.log('Video Containers:', videoContainers);

  if (videoElements.length > 0) {
    videoElements.forEach(function(videoElement) {
      // Setup the PLYR videoplayer for each element
      const player = new Plyr(videoElement, {
        keyboard: {
          global: true,
        },
        tooltips: {
          controls: true,
        },
        captions: {
          active: true,
        },
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'],
        vimeo: {
          // Prevent Vimeo blocking plyr.io demo site
          referrerPolicy: 'no-referrer',
        },
      });
      //console.log('Initialized Plyr for:', videoElement);
    });

    var speed = 5;

    function expanding() {
      var scrolltop = window.pageYOffset; // get number of pixels document has scrolled vertically
      var scrollAndSpeed = (scrolltop / speed);
      //console.log('Scroll top:', scrolltop);

      expandDivs.forEach(function(expandDiv) {
        var videoContainer = expandDiv.closest('[class^="video-container-subpage"]');
        if (!videoContainer) {
          //console.log('No video container found for expandDiv:', expandDiv);
          return;
        }

        var marginTop = window.getComputedStyle(videoContainer).getPropertyValue("margin-top");
        var height = expandDiv.clientHeight;

        var myVideo = expandDiv.querySelector('[class^="mysubpageVideo"]');
        if (!myVideo) {
          //console.log('No video found in expandDiv:', expandDiv);
          return;
        }

        var site_header = document.getElementById("masthead");
        var site_header_height = site_header ? site_header.clientHeight : 0;

        var y = myVideo.getBoundingClientRect().top;
        //console.log('Video Y position:', y);

        var initialBorderRadius = window.getComputedStyle(expandDiv).getPropertyValue("border-radius");

        var expandDivRect = expandDiv.getBoundingClientRect();
        var videoexpanded = false;
        // expand if video is on half of the page
        // get viewport height
        var viewportHeight = window.innerHeight;
        var offset = viewportHeight / 2;

        if (expandDivRect.top <= offset + site_header_height && expandDivRect.bottom >= 0 + site_header_height) {
          videoexpanded = true;
          expandDiv.classList.remove("not-scrolled");
          expandDiv.classList.add("scrolled");
          myVideo.muted = true;
          if (myVideo instanceof HTMLVideoElement) {
            myVideo.play();
            //console.log('Playing video:', myVideo);
          }
        }

        if (expandDivRect.top >= 0 + 200) {
          videoexpanded = false;
          expandDiv.classList.remove("scrolled");
          expandDiv.classList.add("not-scrolled");
          if (myVideo instanceof HTMLVideoElement) {
            myVideo.pause();
            //console.log('Pausing video (top >= 200):', myVideo);
          }
        }

        if (expandDivRect.bottom <= 0) {
          videoexpanded = false;
          expandDiv.classList.remove("scrolled");
          expandDiv.classList.add("not-scrolled");
          if (myVideo instanceof HTMLVideoElement) {
            myVideo.pause();
            //console.log('Pausing video (bottom <= 0):', myVideo);
          }
        }

        if (scrolltop < 1) {
          if (myVideo instanceof HTMLVideoElement) {
            myVideo.pause();
            //console.log('Pausing video (scrolltop < 1):', myVideo);
          }
          expandDiv.classList.remove("scrolled");
          expandDiv.classList.add("not-scrolled");
        }

        if (videoexpanded == false) {
          if (myVideo instanceof HTMLVideoElement) {
            myVideo.pause();
            //console.log('Pausing video (videoexpanded == false):', myVideo);
          }
        }
      });
    }

    window.addEventListener('scroll', function() { // on page scroll
      requestAnimationFrame(expanding); // call expanding()
    }, false);
  } else {
    //console.log('No video elements found.');
  }
});
// end new subpages

//testimonial swiper slider
// only if there is a swiper with the class testimonials-swiper on the page
if (document.querySelector(".testimonials-swiper")) {
var swiper = new Swiper(".testimonials-swiper", {

  
  // slidesPerView: "auto",
  spaceBetween: 0,
  // slides per view
  slidesPerView: 1.8,
  // center slides
  centeredSlides: true,
  // loop: true,
  //  turn off mouse swiperxwx
  // add Pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // add navigation
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: { /* when window >=0px - webflow mobile landscape/portriat */
      slidesPerView:1,
      // turn off navigation
    },
        480: { /* when window >=0px - webflow mobile landscape/portriat */
          slidesPerView: 1,
    },
    767: { /* when window >= 767px - webflow tablet */
      slidesPerView: 1,
    },
    992: { /* when window >= 988px - webflow desktop */
      slidesPerView: 1.3,
    },
    1280: { /* when window >= 988px - webflow desktop */
      slidesPerView: 1.8,
    }
  },
});
// get total slider of the testimonial swiper
var totalSlides = swiper.slides.length;
console.log("The total amount of slides is: " + totalSlides);

// if total slides is less than 2 then slides per view is 1
if (totalSlides < 2) {
  swiper.params.slidesPerView = 1;
  swiper.update();
}
}



// end testimonial swiper slider


// new logo slider
// Initialize Swiper for each container with class starting with "mylogoswiper"

var swipers = document.querySelectorAll(".mynewlogoswiper");
swipers.forEach(function(swiperElement) {
  new Swiper(swiperElement, {
    // slidesPerView: "auto",
    spaceBetween: 0,
    grabCursor: true,
    a11y: false,
    freeMode: true,
    speed: 3000,
    loop: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 0.0,
      disableOnInteraction: false,
       },
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
  });
});


// emploee 
